import { useLocalStorage } from '@rehooks/local-storage';

import useRxConditionId from './useRxConditionId';

/**
 * Hook to get and set the rxId, which is stored in the conditionId as key in localStorage.
 * This hook is needed for local development only and should not be used in production.
 * @returns {string} rxId
 */
export default function useRxId() {
  const [conditionId] = useRxConditionId();
  return useLocalStorage(conditionId, '');
}
